import React, { Component } from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import { userActions } from "../../_actions";
import { AdminMessage, Routes } from "../../_components";
import { userConstants } from "../../_constants";
import "../../assets/css/requestEduStatus.css";
import { BtnRound } from "../../_components/BtnRound";
import { CardSelect } from "../../_components/pdp-card-select";
import { formatDate } from "../../_helpers/formatDate";
Modal.setAppElement("#root");

class RequestEduStatus_ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titles: [],
      courses: [],
    };
    this.globalStorage = this.props.globalStorage;
    this.config = {
      headers: {
        Authorization: this.props.globalStorage.token,
      },
    };
  }

  componentDidMount() {
    this.getTitles();
    this.getCourses();
    document.querySelector(".wave").classList.add("hidden");
  }

  componentWillUnmount = () => {
    document.querySelector(".wave").classList.remove("hidden");
  };

  getTitles = () => {
    this.props
      .dispatch(
        userActions.API(
          "get",
          `v1/user/hospital/course/titles`,
          null,
          true,
          false
        )
      )
      .then((res) => {
        this.setState({ titles: res.data });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  getCourses = () => {
    this.props
      .dispatch(
        userActions.API("get", `v1/user/hospital/courses`, null, true, false)
      )
      .then((res) => {
        this.setState({ courses: res.data });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  render() {
    const { titles, courses } = this.state;
    if (courses.length === 0) return null;
    const { firstname, lastname } = this.globalStorage.me;
    const {
      superior_submitted_at,
      supervisor_submitted_at,
      submitted_at,
      superior,
      user_comment,
      superior_description,
      supervisor_description,
    } = courses[0];
    const dates = [
      submitted_at,
      superior_submitted_at,
      supervisor_submitted_at,
    ];
    const names = [
      `درخـواست کننده نیاز آموزشی (${firstname} ${lastname})`,
      `مافــوق (${superior.firstname} ${superior.lastname})`,
      "سـازمــان",
    ];
    const labels = [
      `${firstname} ${lastname}`,
      `${superior.firstname} ${superior.lastname}`,
      "سـازمــان",
    ];

    return (
      <div className="requestEduStatus bg-light bg-drr pt-3 pb-5 px-3">
        <Routes page="pdp/requestEduStatus" />
        <div className="container-fluid adminMessage">
          <div className="card bg-white shadow text-center border-0">
            <AdminMessage />
          </div>
        </div>
        <br />
        <NotifCard text1="وضعیت نیازسنجی های آموزشی در بیمارستان" />
        <br />
        <Timeline dates={dates} names={names} labels={labels} />
        <div
          className="row mb-4 d-flex justify-content-center align-items-center"
          style={{ gap: "2rem" }}
        >
          {user_comment && (
            <CardSelect
              hideHeader={true}
              hideTitle={true}
              style={{ height: "20vh", overflow: "scroll" }}
              text={user_comment}
              customTitle={
                <div
                  className="d-flex justify-content-between align-items-center px-3 py-2"
                  style={{ width: "280px" }}
                >
                  <p className="m-0 text-primary">کاربر</p>
                  <p className="m-0 text-primary iran-sans-imp">
                    {formatDate(submitted_at)}
                  </p>
                </div>
              }
            />
          )}
          {superior_description && (
            <CardSelect
              hideHeader={true}
              hideTitle={true}
              style={{ height: "20vh", overflow: "scroll" }}
              text={superior_description}
              customTitle={
                <div
                  className="d-flex justify-content-between align-items-center px-3 py-2"
                  style={{ width: "280px" }}
                >
                  <p className="m-0 text-primary">مافوق</p>
                  <p className="m-0 text-primary iran-sans-imp">
                    {formatDate(superior_submitted_at)}
                  </p>
                </div>
              }
            />
          )}
          {supervisor_description && (
            <CardSelect
              hideHeader={true}
              hideTitle={true}
              style={{ height: "20vh", overflow: "scroll" }}
              text={supervisor_description}
              customTitle={
                <div
                  className="d-flex justify-content-between align-items-center px-3 py-2"
                  style={{ width: "280px" }}
                >
                  <p className="m-0 text-primary">مافوق</p>
                  <p className="m-0 text-primary iran-sans-imp">
                    {formatDate(supervisor_submitted_at)}
                  </p>
                </div>
              }
            />
          )}
        </div>
        <div className="container-fluid listContainer px-2 pb-5">
          <div className="row">
            <div className="col-xl-11 col-lg-12 col-md-12 col-sm-12 listContainer2 m-auto">
              <List>
                {courses.length && titles.length ? (
                  Array.from({ length: courses.length }).map((_, i) => (
                    <ListItem
                      i={i}
                      key={i + 1}
                      course={courses[i]}
                      titles={titles}
                    />
                  ))
                ) : (
                  <EmptyListItem />
                )}
              </List>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class Timeline extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.dates.filter((date) => date !== null).length - 1,
      previous: 0,
    };
  }

  render() {
    const { dates, names, labels } = this.props;
    const { value } = this.state;

    return (
      <div className="row timelineParent">
        <div className="col-xl-12 col-lg-12 col-md-11 col-sm-10 indexSec timeline mx-auto mb-3">
          <div className="border-0 h-100 ">
            <div
              className="card border-0 shadow-smm"
              style={{ borderRadius: "20px" }}
            >
              <div className="card-body" style={{ height: "270px" }}>
                <div
                  style={{
                    width: "100%",
                    height: "100px",
                    margin: "0 auto 70px auto",
                  }}
                >
                  <div className="text-center title">
                    <span>
                      نـوار اعلام وضعیت نیازسنجی هـای درخـواست شـده توسـط شمـا
                    </span>
                  </div>
                  <div className="row">
                    <div className="col-12 py-5 d-flex flex-row-reverse justify-content-center align-items-center gap-sm">
                      <div className="position-relative">
                        <BtnRound
                          className={`${
                            value >= 0 ? "bg-primary" : "bg-gray"
                          } basic-logo`}
                          style={{ borderRadius: "50%" }}
                          onClick={() => this.setState({ value: 0 })}
                        />
                        <p
                          className={`position-absolute m-0 btn-text digi-font ${
                            value >= 0 ? "text-primary" : ""
                          }`}
                        >
                          {names[0]}
                        </p>
                      </div>
                      <div
                        className={`line ${value >= 1 ? "line-active" : ""}`}
                      ></div>
                      <div className="position-relative">
                        <BtnRound
                          className={`${
                            value >= 1 ? "bg-primary" : "bg-gray"
                          } payesh-logo`}
                          style={{ borderRadius: "50%" }}
                          onClick={() => this.setState({ value: 1 })}
                        />
                        <p
                          className={`position-absolute m-0 btn-text digi-font ${
                            value >= 1 ? "text-primary" : ""
                          }`}
                        >
                          {names[1]}
                        </p>
                      </div>
                      <div
                        className={`line ${value >= 2 ? "line-active" : ""}`}
                      ></div>
                      <div className="position-relative">
                        <BtnRound
                          className={`${
                            value >= 2 ? "bg-primary" : "bg-gray"
                          } question-logo`}
                          style={{ borderRadius: "50%" }}
                          onClick={() => this.setState({ value: 2 })}
                        />
                        <p
                          className={`position-absolute m-0 btn-text digi-font ${
                            value >= 2 ? "text-primary" : ""
                          }`}
                        >
                          {names[2]}
                        </p>
                      </div>
                    </div>
                  </div>
                  {dates[value] !== null ? (
                    value === 0 ? (
                      <p className="mb-0 mt-4 text-center">
                        {`درخواست ${labels[value]} در تاریخ `}
                        <span className="iran-sans-imp">
                          {formatDate(dates[value])}
                        </span>
                        {`ثبت شد .`}
                      </p>
                    ) : value === 1 ? (
                      <p className="mb-0 mt-4 text-center">
                        {`درخواست شما توسط ${labels[value]} در تاریخ `}
                        <span className="iran-sans-imp">
                          {formatDate(dates[value])}
                        </span>
                        {` بررسی شد.`}
                      </p>
                    ) : (
                      <p className="mb-0 mt-4 text-center">
                        {`درخواست شما توسط ${labels[value]} در تاریخ `}
                        <span className="iran-sans-imp">
                          {formatDate(dates[value])}
                        </span>
                        {` بررسی شد.`}
                      </p>
                    )
                  ) : (
                    <p className="mb-0 mt-4 text-center">
                      این مرحله هنوز تکمیل نشده است
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class EmptyListItem extends Component {
  render() {
    return (
      <li className="requestEduStatus__list__item empty-list">
        <p className="requestEduStatus__list__item__text empty-list__child">
          برای نمایش اطلاعات از دکمه های بالا استفاده نمایید
        </p>
      </li>
    );
  }
}

class NotifCard extends Component {
  render() {
    const { text1, text2, color1 = "#777777", color2 = "#6c00ff" } = this.props;

    return (
      <div className="notif py-3 px-5">
        <p style={{ color: color1, margin: 0 }}>{text1}</p>
        {text2 && (
          <p style={{ color: color2, margin: "10px 0 0 0" }}>{text2}</p>
        )}
      </div>
    );
  }
}

class List extends Component {
  render() {
    return (
      <div className="list-wrapper">
        <ul className="requestEduStatus__list">
          <Banner />
          {this.props.children}
        </ul>
      </div>
    );
  }
}

class Banner extends Component {
  render() {
    return (
      <li className="requestEduStatus__list__banner" key="0">
        <div className="requestEduStatus__list__banner__child">ردیف</div>
        <div className="requestEduStatus__list__banner__child">
          عنوان نیازسنجی
        </div>
        <div className="requestEduStatus__list__banner__child">نظر کاربر</div>
        <div className="requestEduStatus__list__banner__child">نظر مافوق</div>
        <div className="requestEduStatus__list__banner__child">نظر سازمان</div>
        <div className="requestEduStatus__list__banner__child">وضعیت</div>
      </li>
    );
  }
}

class ListItem extends Component {
  render() {
    const { i, course, titles } = this.props;
    const { status } = course;
    const titleObj = titles.find((title) => title.id === course.course_id);
    const title = titleObj ? titleObj.title : "xxx";
    const course_type = titleObj ? titleObj.course_type : "xxx";
    const { superior_comment, requested_by } = course;
    const userHover =
      course_type === "2"
        ? "الزامی توسط سازمان"
        : requested_by === "superior"
        ? "انتخاب شده توسط مافوق"
        : requested_by === "supervisor"
        ? "انتخاب شده توسط سازمان"
        : "انتخاب شده توسط شما";
    let userIcon,
      superiorIcon,
      superiorHover,
      supervisorIcon,
      supervisorHover,
      statusText;

    if (requested_by === "user" && status === "superior_pending") {
      userIcon = course_type === "2" ? "success-dark" : "success";
      superiorIcon = course_type === "2" ? "success-dark" : "waiting";
      supervisorIcon = course_type === "2" ? "success-dark" : "waiting";
      superiorHover =
        supervisorHover =
        statusText =
          course_type === "2"
            ? "الزامی توسط سازمان"
            : "در انتظار اعمال نظر توسط مافوق و سازمان";
    }
    if (requested_by === "user" && status === "supervisor_pending") {
      userIcon = course_type === "2" ? "success-dark" : "success";
      superiorIcon =
        course_type === "2"
          ? "success-dark"
          : superior_comment && superior_comment.length === 0
          ? "dislike"
          : "like";
      supervisorIcon = course_type === "2" ? "success-dark" : "waiting";
      superiorHover =
        supervisorHover =
        statusText =
          course_type === "2"
            ? "الزامی توسط سازمان"
            : `${
                superior_comment && superior_comment.length === 0
                  ? ""
                  : "تایید توسط مافوق"
              } در انتظار اعمال نظر توسط سازمان`;
    }
    if (requested_by === "user" && status === "rejected_by_superior") {
      userIcon = course_type === "2" ? "success-dark" : "success";
      superiorIcon = course_type === "2" ? "success-dark" : "dislike";
      supervisorIcon = course_type === "2" ? "success-dark" : "waiting";
      superiorHover =
        supervisorHover =
        statusText =
          course_type === "2"
            ? "الزامی توسط سازمان"
            : "رد شده توسط مافوق در انتظار اعمال نظر توسط سازمان";
      // supervisor_comment === null || supervisor_comment.length === 0
      //   ? "موافقت نهایی"
      //   : "رد درخواست دوره";
    }
    if (requested_by === "user" && status === "rejected_by_supervisor") {
      userIcon = course_type === "2" ? "success-dark" : "success";
      superiorIcon =
        course_type === "2"
          ? "success-dark"
          : superior_comment === null || superior_comment.length === 0
          ? "like"
          : "dislike";
      supervisorIcon = course_type === "2" ? "success-dark" : "dislike";
      superiorHover =
        supervisorHover =
        statusText =
          course_type === "2" ? "الزامی توسط سازمان" : "رد توسط سازمان";
    }
    if (requested_by === "user" && status === "active") {
      userIcon = course_type === "2" ? "success-dark" : "success";
      superiorIcon =
        course_type === "2"
          ? "success-dark"
          : superior_comment === null || superior_comment.length === 0
          ? "like"
          : "dislike";
      supervisorIcon = course_type === "2" ? "success-dark" : "like";
      superiorHover =
        supervisorHover =
        statusText =
          course_type === "2" ? "الزامی توسط سازمان" : "موافقت نهایی";
    }
    if (requested_by === "superior" && status === "supervisor_pending") {
      userIcon = "empty";
      superiorIcon = "success";
      supervisorIcon = "waiting";
      superiorHover =
        supervisorHover =
        statusText =
          "انتخاب شده توسط مافوق و در انتظار اعمال نظر توسط سازمان";
    }
    if (requested_by === "superior" && status === "rejected_by_supervisor") {
      userIcon = "empty";
      superiorIcon = "success";
      supervisorIcon = "dislike";
      superiorHover =
        supervisorHover =
        statusText =
          "درخواست توسط مافوق و رد توسط سازمان";
    }
    if (requested_by === "superior" && status === "active") {
      userIcon = "empty";
      superiorIcon = "success";
      supervisorIcon = "like";
      superiorHover =
        supervisorHover =
        statusText =
          "درخواست توسط مافوق و تایید توسط سازمان";
    }
    if (requested_by === "supervisor" && status === "active") {
      userIcon = "empty";
      superiorIcon = "empty";
      supervisorIcon = "success";
      superiorHover = supervisorHover = statusText = "انتخاب شده توسط سازمان";
    }

    return (
      <li className={`requestEduStatus__list__item`}>
        <ListItemBtnContainer>
          <p className="requestEduStatus__list__item__text">{i + 1}</p>
        </ListItemBtnContainer>
        <ListItemBtnContainer className="title">
          <p className="requestEduStatus__list__item__text" data-tip={title}>
            {title}
          </p>
        </ListItemBtnContainer>
        <ListItemBtnContainer className="btn-1">
          <BtnRound data_tip={userHover} className={`${userIcon}-icon`} />
        </ListItemBtnContainer>
        <ListItemBtnContainer className="btn-2">
          <BtnRound
            data_tip={superiorHover}
            className={`${superiorIcon}-icon`}
          />
        </ListItemBtnContainer>
        <ListItemBtnContainer className="btn-3">
          <BtnRound
            data_tip={supervisorHover}
            className={`${supervisorIcon}-icon`}
          />
        </ListItemBtnContainer>
        <ListItemBtnContainer className="descrip">
          <p className="requestEduStatus__list__item__text">{statusText}</p>
        </ListItemBtnContainer>
        <ReactTooltip type="dark" />
      </li>
    );
  }
}

class ListItemBtnContainer extends Component {
  render() {
    return (
      <div
        className={`${this.props.className} requestEduStatus__list__item__btn-container`}
      >
        {this.props.children}
        {/* <ReactTooltip type="dark" /> */}
      </div>
    );
  }
}

class Textarea extends Component {
  render() {
    return (
      <textarea
        className={`special-textarea ${this.props.className}`}
        placeholder={`${this.props.placeholder || ""}`}
        value={this.props.value || ""}
        onChange={this.props.onChange}
        style={this.props.style}
      />
    );
  }
}

const RequestEduStatus = connect((state) => ({
  globalStorage: state.globalStorage,
}))(RequestEduStatus_);
export { RequestEduStatus };
